import _uniq from "lodash/uniq";
import { IFormSchema } from "../models/IFormSchema";


const defaultActionTypes = [
    "remove",
    "require",
    "uiAppend",
    "uiOverride",
    "uiRepalce"
]
/**
 * returns list of all actions used in form schema
 * @param uiProp
 */
export const getSchemaActionTypes = (formSchema: IFormSchema, onlyExtraActions: boolean = false) => {
    let names: Array<string> = [];

    const { rules = [] } = formSchema;

    rules.forEach((rule) => {
        let eventTypes = Array.isArray(rule.event)
            ? rule.event.map((event) => event.type)
            : [rule.event.type];
        eventTypes = onlyExtraActions ? eventTypes.filter((type) => !defaultActionTypes.includes(type)) : eventTypes;
        names = names.concat(eventTypes);
    })


    return _uniq(names);
};